import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import Box from '../Box';

function ScreenReader(props) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    css: {
      width: '1px',
      height: '1px',
      padding: 0,
      margin: '-1px',
      border: 0,
      position: 'absolute',
      clip: 'rect(1px, 1px, 1px, 1px)',
      overflow: 'hidden',
      '&:focus-within': {
        width: 'auto',
        height: 'auto',
        margin: 0,
        clip: 'auto',
        position: 'static',
        overflow: 'initial'
      }
    }
  }, props));
}

export default ScreenReader;